<template>
    <div id="modelDetailPage">
        <modelDetail :id="id"/>
    </div>
</template>

<script>
import modelDetail from '@/components/lib/modelDetail.vue';

export default{
    name:'modelDetailPage',
    components:{
        modelDetail
    },
    data(){
        return{
            id:0
        }
    },
    watch:{
        '$route.query': function (v) {
            if(v?.id){
                this.id = v.id;
            }
        }
    },
    methods:{
        getId(){
            let id = this.$route.query?.id;
            this.id = id?id:-1;
        }
    },
    created(){
        this.getId();
    },
}
</script>

<style lang="scss" scoped src="@/assets/css/modelDetailPage.scss"></style>